import {UserType} from "../../../Types/UserType";
import React from "react";
import {useFormContext} from "react-hook-form";

export default function SaleDepartments({user}: {user: UserType}): React.ReactElement {
    const form = useFormContext();

    return (
        <div className={'option sale-departments'} >
            <h1>Wybierz dział</h1>

            <div className={'scrollable'} >
                {user.salesDepartmentInfo.map((saleDepartment: any, key: number) => {
                    return (
                        <div key={key} >
                            <input type={'radio'} checked={user.salesDepartmentInfo.length === 1 ? true : undefined} {...form.register('saleDepartment')} value={saleDepartment.hostName} required={true} />
                            <span>{saleDepartment.name}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}